import React, { useEffect, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import esLocale from "@fullcalendar/core/locales/es";
import { obtenerFechasCalibracion } from "../services/calibracionesService";
import { useNavigate } from "react-router-dom";
import "./Calendario.css";

function Calendario() {
  const [eventos, setEventos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorCarga, setErrorCarga] = useState('');
  const [reintento, setReintento] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    let cancelado = false;

    const cargarEventos = async () => {
      setLoading(true);
      setErrorCarga('');

      try {
        const resultado = await obtenerFechasCalibracion();

        if (!cancelado) {
          setEventos(resultado.eventos || []);
        }
      } catch (error) {
        console.error('❌ Error cargando calendario:', error);

        if (!cancelado) {
          setEventos([]);
          setErrorCarga(
            'No se pudo cargar el calendario. Verifica tu conexión e inténtalo nuevamente.'
          );
        }
      } finally {
        if (!cancelado) {
          setLoading(false);
        }
      }
    };

    cargarEventos();

    return () => {
      cancelado = true;
    };
  }, [reintento]);
  if (loading) {
    return (
      <div className="mx-auto w-full max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
        <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
          <p className="text-sm text-slate-500">
            Cargando calendario...
          </p>
        </div>
      </div>
    );
  }

  if (errorCarga) {
    return (
      <div className="mx-auto w-full max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
        <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
          <div className="rounded-lg border border-red-200 bg-red-50 p-4 text-sm text-red-700">
            {errorCarga}
          </div>

          <button
            onClick={() => setReintento((valor) => valor + 1)}
            className="mt-4 h-10 rounded-lg bg-cyan-600 px-4 text-sm font-semibold text-white transition hover:bg-cyan-700"
          >
            Reintentar
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="mx-auto w-full max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
      <div className="mb-6">
        <p className="mb-2 text-xs font-semibold uppercase tracking-[0.18em] text-cyan-600">
          Calibraciones
        </p>

        <h1 className="text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">
          Calendario de calibración
        </h1>

        <p className="mt-2 max-w-2xl text-sm leading-6 text-slate-600">
          Consulta las próximas fechas de calibración y localiza rápidamente los
          instrumentos programados.
        </p>
      </div>

      {eventos.length === 0 && (
        <div className="mb-4 rounded-lg border border-slate-200 bg-white p-4 text-sm text-slate-600 shadow-sm">
          No hay calibraciones programadas con fecha próxima.
        </div>
      )}

      <div className="smartgage-calendar overflow-hidden rounded-2xl border border-slate-200 bg-white p-4 shadow-sm sm:p-6">
        <FullCalendar
          plugins={[dayGridPlugin, interactionPlugin]}
          initialView="dayGridMonth"
          locale={esLocale}
          events={eventos}
          height="auto"
          eventDidMount={(info) => {
            const tooltip = `
  🆔 ${info.event.title}
  📍 Ubicación: ${info.event.extendedProps.ubicacion}
  👤 Asignado: ${info.event.extendedProps.asignado}
  📄 Certificado: ${info.event.extendedProps.certificado}
            `;
           info.el.setAttribute("title", tooltip.trim());
          }}
          eventClick={(info) => {
            info.jsEvent.preventDefault();

            if (info.event.id) {
              navigate(`/instrumentos/editar/${info.event.id}`);
            }
          }}
        />
      </div>
    </div>
  );
}

export default Calendario;